



// 77777777777777777777777

// onboardingSlice.js - COMPLETE WORKING VERSION
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

// ================= API CALLS =================
export const fetchPendingOnboarding = createAsyncThunk(
  "onboarding/fetchPending",
  async (_, { rejectWithValue }) => {
    try {
      console.log("🔄 Fetching pending registrations...");
      
      const response = await axiosInstance.get('/api/admin-onboarding/pending-registrations');
      console.log("✅ API Response:", response.data);
      
      if (response.data.success) {
        console.log(`📊 Found ${response.data.data?.length || 0} pending users`);
        return response.data.data || [];
      } else {
        console.error("❌ API Error:", response.data.message);
        return rejectWithValue(response.data.message);
      }
      
    } catch (err) {
      console.error("❌ Network Error:", {
        message: err.message,
        status: err.response?.status,
        data: err.response?.data
      });
      return rejectWithValue(
        err.response?.data?.message || 
        err.response?.data?.error || 
        err.message || 
        "Network Error"
      );
    }
  }
);

export const completeOnboarding = createAsyncThunk(
  "onboarding/complete",
  async ({ employeeId, employeeData }, { rejectWithValue }) => {
    try {
      console.log("🚀 Completing onboarding for:", employeeId);
      console.log("📦 Sending data:", employeeData);
      
      const response = await axiosInstance.put(
        `/api/admin-onboarding/complete-onboarding/${employeeId}`,
        employeeData
      );
      
      console.log("✅ Onboarding response:", response.data);
      
      if (response.data.success) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message);
      }
      
    } catch (err) {
      console.error("❌ Onboarding failed:", {
        message: err.message,
        status: err.response?.status,
        data: err.response?.data
      });
      
      return rejectWithValue(
        err.response?.data?.message || 
        err.response?.data?.error || 
        err.message || 
        "Failed to complete onboarding"
      );
    }
  }
);

export const deletePendingRegistration = createAsyncThunk(
  "onboarding/delete",
  async (employeeId, { rejectWithValue }) => {
    try {
      console.log("🗑️ Deleting:", employeeId);
      
      const response = await axiosInstance.delete(
        `/api/admin-onboarding/pending-registration/${employeeId}`
      );
      
      console.log("✅ Delete response:", response.data);
      
      if (response.data.success) {
        return employeeId;
      } else {
        return rejectWithValue(response.data.message);
      }
      
    } catch (err) {
      console.error("❌ Delete error:", err);
      return rejectWithValue(
        err.response?.data?.message || 
        err.response?.data?.error || 
        err.message
      );
    }
  }
);

// ================= SLICE =================
const onboardingSlice = createSlice({
  name: "onboarding",
  initialState: {
    pendingEmployees: [],
    pendingLoading: false,
    pendingError: null,
    completeLoading: false,
    completeError: null,
    selectedEmployee: null,
    searchTerm: "",
    successMessage: null,
  },
  reducers: {
    setSelectedEmployee: (state, action) => {
      console.log("👤 Setting selected employee:", action.payload?._id);
      state.selectedEmployee = action.payload;
    },
    
    clearSelectedEmployee: (state) => {
      state.selectedEmployee = null;
    },
    
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
    
    clearPendingError: (state) => {
      state.pendingError = null;
    },
    
    clearCompleteError: (state) => {
      state.completeError = null;
    },
    
    clearAllErrors: (state) => {
      state.pendingError = null;
      state.completeError = null;
    },
    
    resetOnboardingState: (state) => {
      state.pendingEmployees = [];
      state.selectedEmployee = null;
      state.searchTerm = "";
      state.successMessage = null;
      state.pendingError = null;
      state.completeError = null;
      state.pendingLoading = false;
      state.completeLoading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      // ===== FETCH PENDING =====
      .addCase(fetchPendingOnboarding.pending, (state) => {
        state.pendingLoading = true;
        state.pendingError = null;
      })
      .addCase(fetchPendingOnboarding.fulfilled, (state, action) => {
        state.pendingLoading = false;
        state.pendingEmployees = action.payload || [];
        console.log("✅ State updated with", state.pendingEmployees.length, "users");
      })
      .addCase(fetchPendingOnboarding.rejected, (state, action) => {
        state.pendingLoading = false;
        state.pendingError = action.payload;
        console.error("❌ Fetch rejected:", action.payload);
      })
      
      // ===== COMPLETE ONBOARDING =====
      .addCase(completeOnboarding.pending, (state) => {
        state.completeLoading = true;
        state.completeError = null;
        state.successMessage = null;
      })
      .addCase(completeOnboarding.fulfilled, (state, action) => {
        state.completeLoading = false;
        state.successMessage = action.payload.message;
        
        // Remove from pending list
        state.pendingEmployees = state.pendingEmployees.filter(
          emp => emp._id !== action.payload.data._id
        );
        
        state.selectedEmployee = null;
        console.log("✅ Onboarding completed, removed from list");
      })
      .addCase(completeOnboarding.rejected, (state, action) => {
        state.completeLoading = false;
        state.completeError = action.payload;
        console.error("❌ Onboarding rejected:", action.payload);
      })
      
      // ===== DELETE PENDING =====
      .addCase(deletePendingRegistration.pending, (state) => {
        state.pendingLoading = true;
      })
      .addCase(deletePendingRegistration.fulfilled, (state, action) => {
        state.pendingLoading = false;
        
        // Remove from pending list
        state.pendingEmployees = state.pendingEmployees.filter(
          emp => emp._id !== action.payload
        );
        
        // Clear selected if deleted
        if (state.selectedEmployee?._id === action.payload) {
          state.selectedEmployee = null;
        }
        
        console.log("✅ Deleted from state:", action.payload);
      })
      .addCase(deletePendingRegistration.rejected, (state, action) => {
        state.pendingLoading = false;
        state.pendingError = action.payload;
        console.error("❌ Delete rejected:", action.payload);
      });
  }
});

export const {
  setSelectedEmployee,
  clearSelectedEmployee,
  setSearchTerm,
  clearSuccessMessage,
  clearPendingError,
  clearCompleteError,
  clearAllErrors,
  resetOnboardingState
} = onboardingSlice.actions;

export default onboardingSlice.reducer;